<template>
  <div class="meal-planner-container" :style="{ backgroundImage: `url(${backgroundImage})` }">
    <a class="back-button" @click="goBack">⬅ {{back_label[language]}}</a>

    <!-- Game Stats (Score, Timer) -->
    <div class="game-stats">
      <div class="game-info">{{ Round_label[language] }}: {{ Math.min(round + 1, maxRounds + 1) }} / {{ maxRounds + 1 }}</div>
      <div class="score">{{score_label[language]}}: {{ score }}</div>
      <!-- <div class="timer">{{ timeleft_label[language] }}: {{ timeLeft }}s</div> -->
    </div>


    <div class="middle-left-container-1">
      <!-- Slot: Breakfast -->
      <div class="category-container" :key="'breakfast'">
        <table class="table"
          style="width: 100%; text-align: center; vertical-align: middle; border: 2px solid black; border-collapse: collapse;">
          <tbody>
            <tr>
              <!-- First Column: Category Name -->
              <td
                style="width: 100px; text-align: center; vertical-align: middle; word-wrap: break-word; white-space: normal; border: 2px solid black;">
                <h3>{{breakfast_label[language]}}</h3>
              </td>
              <!-- Second Column: Draggable List -->
              <td style="text-align: center; vertical-align: middle; border: 2px solid black;color: white;">
                <draggable class="list-group horizontal-list bordered" :list="slot.breakfast"
                  :group="{ name: 'food', pull: false, put: true }" @change="placeFoodInSlot('breakfast')"
                  itemKey="name">
                  <template #item="{ element }">
                    <div class="list-group-item">
                      <img :src="element.src" :alt="element.name" class="img-fluid"
                        style="width: 20px; height: 20px;" />
                    </div>
                  </template>
                </draggable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="middle-left-container-2">
      <!-- Slot: Morning Snack -->
      <div class="category-container" :key="'morning_snack'">
        <table class="table"
          style="width: 100%; text-align: center; vertical-align: middle; border: 2px solid black; border-collapse: collapse;">
          <tbody>
            <tr>
              <!-- First Column: Category Name -->
              <td
                style="width: 100px; text-align: center; vertical-align: middle; word-wrap: break-word; white-space: normal; border: 2px solid black;">
                <h3>{{morning_snack_label[language]}}</h3>
              </td>
              <!-- Second Column: Draggable List -->
              <td style="text-align: center; vertical-align: middle; border: 2px solid black;color: white">
                <draggable class="list-group horizontal-list bordered" :list="slot.morning_snack"
                  :group="{ name: 'food', pull: false, put: true }" @change="placeFoodInSlot('morning_snack')"
                  itemKey="name">
                  <template #item="{ element }">
                    <div class="list-group-item">
                      <img :src="element.src" :alt="element.name" class="img-fluid"
                        style="width: 20px; height: 20px;" />
                    </div>
                  </template>
                </draggable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="middle-left-container-3">
      <!-- Slot: Lunch -->
      <div class="category-container" :key="'lunch'">
        <table class="table"
          style="width: 100%; text-align: center; vertical-align: middle; border: 2px solid black; border-collapse: collapse;">
          <tbody>
            <tr>
              <!-- First Column: Category Name -->
              <td
                style="width: 100px; text-align: center; vertical-align: middle; word-wrap: break-word; white-space: normal; border: 2px solid black;">
                <h3>{{lunch_label[language]}}</h3>
              </td>
              <!-- Second Column: Draggable List -->
              <td style="text-align: center; vertical-align: middle; border: 2px solid black;color: white">
                <draggable class="list-group horizontal-list bordered" :list="slot.lunch"
                  :group="{ name: 'food', pull: false, put: true }" @change="placeFoodInSlot('lunch')" itemKey="name">
                  <template #item="{ element }">
                    <div class="list-group-item">
                      <img :src="element.src" :alt="element.name" class="img-fluid"
                        style="width: 20px; height: 20px;" />
                    </div>
                  </template>
                </draggable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="middle-left-container-4">
      <!-- Slot: Afternoon Snack -->
      <div class="category-container" :key="'afternoon_snack'">
        <table class="table"
          style="width: 100%; text-align: center; vertical-align: middle; border: 2px solid black; border-collapse: collapse;">
          <tbody>
            <tr>
              <!-- First Column: Category Name -->
              <td
                style="width: 100px; text-align: center; vertical-align: middle; word-wrap: break-word; white-space: normal; border: 2px solid black;">
                <h3>{{afternoon_snack_label[language]}}</h3>
              </td>
              <!-- Second Column: Draggable List -->
              <td style="text-align: center; vertical-align: middle; border: 2px solid black;color: white">
                <draggable class="list-group horizontal-list bordered" :list="slot.afternoon_snack"
                  :group="{ name: 'food', pull: false, put: true }" @change="placeFoodInSlot('afternoon_snack')"
                  itemKey="name">
                  <template #item="{ element }">
                    <div class="list-group-item">
                      <img :src="element.src" :alt="element.name" class="img-fluid"
                        style="width: 20px; height: 20px;" />
                    </div>
                  </template>
                </draggable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="middle-left-container-5">
      <!-- Slot: Dinner -->
      <div class="category-container" :key="'dinner'">
        <table class="table"
          style="width: 100%; text-align: center; vertical-align: middle; border: 2px solid black; border-collapse: collapse;">
          <tbody>
            <tr>
              <!-- First Column: Category Name -->
              <td
                style="width: 100px; text-align: center; vertical-align: middle; word-wrap: break-word; white-space: normal; border: 2px solid black;">
                <h3>{{dinner_label[language]}}</h3>
              </td>
              <!-- Second Column: Draggable List -->
              <td style="text-align: center; vertical-align: middle; border: 2px solid black;color: white">
                <draggable class="list-group horizontal-list bordered" :list="slot.dinner"
                  :group="{ name: 'food', pull: false, put: true }" @change="placeFoodInSlot('dinner')" itemKey="name">
                  <template #item="{ element }">
                    <div class="list-group-item">
                      <img :src="element.src" :alt="element.name" class="img-fluid"
                        style="width: 20px; height: 20px;" />
                    </div>
                  </template>
                </draggable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- First column: currentFoods -->
    <div class="middle-right-container">
      <draggable class="food-container" :list="currentFoods" @change="log" itemKey="name"
        :group="{ name: 'food', pull: 'clone', put: false }">
        <template #item="{ element }">
          <div class="food-container-item">
            <img :src="element.src" :alt="element.name" class="img-fluid">
            <div>{{element.name[language] }}</div>
            <!-- <div>{{ element.category }}</div> -->
          </div>
        </template>
      </draggable>
    </div>

    <MorningWinOverlay :message="overlayMessage[language]" :visible="isMorningWinOverlayVisible" />
    <MorningLoseOverlay :message="overlayMessage[language]" :visible="isMorningLoseOverlayVisible" />
    <NoonWinOverlay :message="overlayMessage[language]" :visible="isNoonWinOverlayVisible" />
    <NoonLoseOverlay :message="overlayMessage[language]" :visible="isNoonLoseOverlayVisible" />
    <AfternoonWinOverlay :message="overlayMessage[language]" :visible="isAfternoonWinOverlayVisible" />
    <AfternoonLoseOverlay :message="overlayMessage[language]" :visible="isAfternoonLoseOverlayVisible" />
    <EveningWinOverlay :message="overlayMessage[language]" :visible="isEveningWinOverlayVisible" />
    <EveningLoseOverlay :message="overlayMessage[language]" :visible="isEveningLoseOverlayVisible" />
    <ProfPepOverlay :message="overlayMessage[language]" :visible="isOverlayVisible" @start-game="onStartGame" />

    <!-- Badge for Success/Fail -->
    <div v-if="badgeMessage" :class="['badge', badgeType]">{{ badgeMessage }}</div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ProfPepOverlay from '@/components/ProfPepOverlay.vue';
import MorningWinOverlay from '@/components/MorningWinOverlay.vue';
import MorningLoseOverlay from '@/components/MorningLoseOverlay.vue';
import NoonWinOverlay from '@/components/NoonWinOverlay.vue';
import NoonLoseOverlay from '@/components/NoonLoseOverlay.vue';
import AfternoonWinOverlay from '@/components/AfternoonWinOverlay.vue';
import AfternoonLoseOverlay from '@/components/AfternoonLoseOverlay.vue';
import EveningWinOverlay from '@/components/EveningWinOverlay.vue';
import EveningLoseOverlay from '@/components/EveningLoseOverlay.vue';
import { Howler } from 'howler';
import { sounds } from '@/utils/sounds';

export default {
  components: {
    draggable,
    ProfPepOverlay,
    MorningWinOverlay,
    MorningLoseOverlay,
    NoonWinOverlay,
    NoonLoseOverlay,
    AfternoonWinOverlay,
    AfternoonLoseOverlay,
    EveningWinOverlay,
    EveningLoseOverlay,
  },
  data() {
    return {
      language: 'en',
      back_label : {en:"Back", el:"Πίσω", it:"Indietro", ro:"Înapoi", uk:"Назад"},
      Round_label: {en:"Round", el:"Γύρος", it:"Round", ro:"Rundă", uk:"Раунд"},
      score_label: {en:"Score", el:"Πόντοι", it:"Punteggio", ro:"Scor", uk:"Рахунок"},
      correct_label: {en:"Correct!", el:"Σωστά!", it:"Corretto", ro:"Corect!", uk:"Правильно!"},
      wrong_label: {en:"Wrong...", el:"Λάθος...", it:"Sbagliato", ro:"Greșit...", uk:"Неправильно..."},
      breakfast_label : {en:"Breakfast", el:"Πρωινό", it:"Colazione", ro:"Mic dejun", uk:"Сніданок"},
      morning_snack_label : {en:"Morning snack", el:"Πρωινό σνακ", it:"Spuntino mattutino", ro:"Gustare de dimineață", uk:"Ранковий перекус"},
      lunch_label : {en:"Lunch", el:"Μεσημεριανό", it:"Pranzo", ro:"Prânz", uk:"Обід"},
      afternoon_snack_label : {en:"Afternoon snack", el:"Απογευματινό σνακ", it:"Spuntino pomeridiano", ro:"Gustare de după-amiază", uk:"Післяобідній перекус"},
      dinner_label : {en:"Dinner", el:"Βραδινό", it:"Cena", ro:"Cină", uk:"Вечеря"},

      isSyncing: false,

      daypart: '', // Initialize daypart
      overlayMessage: {     en: 'This is the message',     el: "Αυτό είναι το μήνυμα",     it: "Questo è il messaggio",     ro: "Acesta este mesajul",     uk: "Це повідомлення" },      isOverlayVisible: true,
      isMorningWinOverlayVisible: false,
      isMorningLoseOverlayVisible: false,
      isNoonWinOverlayVisible: false,
      isNoonLoseOverlayVisible: false,
      isAfternoonWinOverlayVisible: false,
      isAfternoonLoseOverlayVisible: false,
      isEveningWinOverlayVisible: false,
      isEveningLoseOverlayVisible: false,
      backgroundImage: require('@/assets/game-backgrounds/background.jpg'),
      audio: null,

      categories: {
        breakfast: [
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name:  {en:'apple', el:'μήλο', it:'mela', ro:'măr', uk:'яблуко'}, src: require('@/assets/game-elements/breakfast/apple.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'avocado', el:'αβοκάντο', it:'avocado', ro:'avocado', uk:'авокадо'}, src: require('@/assets/game-elements/breakfast/avocado.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'banana', el:'μπανάνα', it:'banana', ro:'banană', uk:'банан'}, src: require('@/assets/game-elements/breakfast/banana.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'cereals', el:'σιτηρά', it:'cereali', ro:'cereale', uk:'крупи'}, src: require('@/assets/game-elements/breakfast/cereals.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'cookie', el:'κουλουράκι', it:'biscotto', ro:'prăjitură', uk:'печиво'}, src: require('@/assets/game-elements/breakfast/cookie.png') },
          { category: "breakfast", name: {en:'eggs', el:'αυγά', it:'uova', ro:'ouă', uk:'яйця'}, src: require('@/assets/game-elements/breakfast/eggs-1.png') },
          { category: "breakfast", name: {en:'eggs', el:'αυγά', it:'uova', ro:'ouă', uk:'яйця'}, src: require('@/assets/game-elements/breakfast/eggs.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'fruits', el:'φρούτα', it:'frutta', ro:'fructe', uk:'фрукти'}, src: require('@/assets/game-elements/breakfast/fruits.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'milk', el:'γάλα', it:'latte', ro:'lapte', uk:'молоко'}, src: require('@/assets/game-elements/breakfast/milk-1.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'milk', el:'γάλα', it:'latte', ro:'lapte', uk:'молоко'}, src: require('@/assets/game-elements/breakfast/milk.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'nuts', el:'ξηροί καρποί', it:'noci', ro:'nuci', uk:'горіхи'}, src: require('@/assets/game-elements/breakfast/nuts.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'peanut butter', el:'φυστικοβούτυρο', it:'burro di arachidi', ro:'unt de arahide', uk:'арахісове масло'}, src: require('@/assets/game-elements/breakfast/peanut butter.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'ricotta cheese', el:'τυρί ρικότα', it:'ricotta', ro:'brânză ricotta', uk:'сир Рікотта'}, src: require('@/assets/game-elements/breakfast/ricotta_cheese.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'toast', el:'τοστ', it:'toast', ro:'toast', uk:'тости'}, src: require('@/assets/game-elements/breakfast/toast-1.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'toast', el:'τοστ', it:'toast', ro:'toast', uk:'тости'}, src: require('@/assets/game-elements/breakfast/toast.png') },
          { category: ["breakfast", "lunch" , "dinner"], name: {en:'whole-wheat bread', el:'ψωμί ολικής αλέσεως', it:'pane integrale', ro:'pâine integrală', uk:'цільнозерновий хліб'}, src: require('@/assets/game-elements/breakfast/whole-wheat bread.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'yogurt', el:'γιαούρτι', it:'yogurt', ro:'iaurt', uk:'йогурт'}, src: require('@/assets/game-elements/breakfast/yogurt.png') },
          { category: ["breakfast", "afternoon_snack", "afternoon_snack"], name: {en:'chia seeds', el:'σπόροι τσία', it:'semi di chia', ro:'seminte de chia', uk:'насіння чіа'}, src: require('@/assets/game-elements/breakfast/chia_seeds.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'muesli', el:'μούσλι', it:'naan', ro:'musli', uk:'мюслі'}, src: require('@/assets/game-elements/breakfast/muesli.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'oats', el:'βρώμη', it:'avena', ro:'ovăz', uk:'овес'}, src: require('@/assets/game-elements/breakfast/oats.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'walnuts', el:'καρύδια', it:'noci', ro:'nuci', uk:'волоські горіхи'}, src: require('@/assets/game-elements/breakfast/walnuts.png') },
        ],
        morning_snack: [
          { category: ["morning_snack", "lunch", "afternoon_snack", "dinner"], name: {en:'arugula', el:'ρόκα', it:'rucola', ro:'voinicică', uk:'рукола'}, src: require('@/assets/game-elements/morning_snack/arugula.png') },
          { category: ["morning_snack", "afternoon_snack"], name: {en:'bresaola', el:'μπρεζάολα', it:'bresaola', ro:'bresaola', uk:'брезаола'}, src: require('@/assets/game-elements/morning_snack/bresaola.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'cheese', el:'τυρί', it:'formaggio', ro:'brânză', uk:'сир'}, src: require('@/assets/game-elements/morning_snack/cheese.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'dried fruits', el:'αποξηραμένα φρούτα', it:'frutta secca', ro:'fructe uscate', uk:'сухофрукти'}, src: require('@/assets/game-elements/morning_snack/dried_fruits.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'pear', el:'αχλάδι', it:'pera', ro:'pară', uk:'груша'}, src: require('@/assets/game-elements/morning_snack/pear.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'pineapple', el:'ανανάς', it:'ananas', ro:'ananas', uk:'ананас'}, src: require('@/assets/game-elements/morning_snack/pineapple.png') },
          { category: ["morning_snack", "afternoon_snack"], name: {en:'popcorn', el:'ποπ κορν', it:'popcorn', ro:'Popcorn', uk:'попкорн'}, src: require('@/assets/game-elements/morning_snack/pop_corn.png') },
          { category: ["breakfast", "morning_snack", "lunch", "afternoon_snack", "dinner"], name: {en:'fresh cheese', el:'φρέσκο ​​τυρί', it:'formaggio fresco', ro:'brânză proaspătă', uk:'свіжий сир'}, src: require('@/assets/game-elements/lunch/fresh cheese.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'almonds', el:'αμύγδαλα', it:'mandorle', ro:'migdale', uk:'мигдаль'}, src: require('@/assets/game-elements/morning_snack/almonds.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'cashews', el:'κάσιους', it:'anacardi', ro:'caju', uk:'кешью'}, src: require('@/assets/game-elements/morning_snack/cashews.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'nutritional yeast', el:'διατροφική μαγιά', it:'lievito nutrizionale', ro:'drojdie nutritivă', uk:'харчові дріжджі'}, src: require('@/assets/game-elements/morning_snack/nutritional_yeast.png') },
        
        ],
        lunch: [
          { category: ["lunch", "dinner"], name: {en:'beans', el:'φασόλια', it:'fagioli', ro:'fasole', uk:'квасоля'}, src: require('@/assets/game-elements/lunch/beans.png') },
          { category: ["lunch", "dinner"], name: {en:'beef', el:'βοδινό κρέας', it:'manzo', ro:'vită', uk:'яловичина'}, src: require('@/assets/game-elements/lunch/beef.png') },
          { category: ["lunch", "dinner"], name: {en:'chicken', el:'κοτόπουλο', it:'pollo', ro:'pui', uk:'курка'}, src: require('@/assets/game-elements/lunch/chicken.png') },
          { category: ["lunch", "dinner"], name: {en:'chickpeas', el:'ρεβίθια', it:'ceci', ro:'naut', uk:'нут'}, src: require('@/assets/game-elements/lunch/chickpeas.png') },
          { category: ["lunch", "dinner"], name: {en:'couscous', el:'κουσκούς', it:'couscous', ro:'cuscus', uk:'кус-кус'}, src: require('@/assets/game-elements/lunch/couscous.png') },
          { category: ["lunch", "dinner"], name: {en:'fish', el:'ψάρι', it:'pesce', ro:'peşte', uk:'риба'}, src: require('@/assets/game-elements/lunch/fish.png') },
          { category: ["lunch", "dinner"], name: {en:'lentils', el:'φακή', it:'lenticchie', ro:'linte', uk:'сочевиця'}, src: require('@/assets/game-elements/lunch/lentils.png') },
          { category: ["lunch", "dinner"], name: {en:'meat', el:'κρέας', it:'carne', ro:'carne', uk:'м\'ясо'}, src: require('@/assets/game-elements/lunch/meat-1.png') },
          { category: ["lunch", "dinner"], name: {en:'meat', el:'κρέας', it:'carne', ro:'carne', uk:'м\'ясо'}, src: require('@/assets/game-elements/lunch/meat.png') },
          { category: ["lunch", "dinner"], name: {en:'peas', el:'αρακάς', it:'piselli', ro:'mazăre', uk:'горох'}, src: require('@/assets/game-elements/lunch/peas.png') },
          { category: ["lunch", "dinner"], name: {en:'pizza', el:'πίτσα', it:'pizza', ro:'pizza', uk:'піца'}, src: require('@/assets/game-elements/lunch/pizza.png') },
          { category: ["lunch", "dinner"], name: {en:'quinoa', el:'κινόα', it:'riso', ro:'Quinoa', uk:'кіноа'}, src: require('@/assets/game-elements/lunch/quinoa.png') },
          { category: ["lunch", "dinner"], name: {en:'rice', el:'ρύζι', it:'riso', ro:'orez', uk:'рис'}, src: require('@/assets/game-elements/lunch/rice.png') },
          { category: ["breakfast", "lunch" , "dinner"], name: {en:'rye bread', el:'σικαλένιο ψωμί', it:'pane piccolo', ro:'pâine de secară', uk:'житній хліб'}, src: require('@/assets/game-elements/lunch/rye bread.png') },
          { category: ["lunch", "dinner"], name: {en:'salmon', el:'σολομός', it:'salmone', ro:'somon', uk:'лосось'}, src: require('@/assets/game-elements/lunch/salmon - tuna.png') },
          { category: ["lunch", "dinner"], name: {en:'tuna', el:'τόνος', it:'tonno', ro:'ton', uk:'тунець'}, src: require('@/assets/game-elements/lunch/salmon - tuna.png') },
          { category: ["lunch", "dinner"], name: {en:'trout', el:'πεστρόφα', it:'trota', ro:'păstrăv', uk:'форель'}, src: require('@/assets/game-elements/lunch/trout.png') },
          { category: ["lunch", "dinner"], name: {en:'barley', el:'κριθάρι', it:'orzo', ro:'orz', uk:'ячмінь'}, src: require('@/assets/game-elements/lunch/barley.png') },
          { category: ["lunch", "dinner"], name: {en:'bulgur', el:'πλιγούρι', it:'bulgur', ro:'bulgur', uk:'булгур'}, src: require('@/assets/game-elements/lunch/bulgur.png') },
          { category: ["lunch", "dinner"], name: {en:'farro', el:'δίκοκκο σιτάρι', it:'farro', ro:'farro', uk:'фарро'}, src: require('@/assets/game-elements/lunch/farro.png') },
          { category: ["lunch", "dinner"], name: {en:'mackerel', el:'σκουμπρί', it:'sgombro', ro:'macrou', uk:'скумбрія'}, src: require('@/assets/game-elements/lunch/mackerel.png') },
          { category: ["lunch", "dinner"], name: {en:'wild boar', el:'αγριόχοιρος', it:'cinghiale', ro:'mistret', uk:'дикий кабан'}, src: require('@/assets/game-elements/lunch/wild_boar.png') },
        
        ],
        afternoon_snack: [
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'berries', el:'μούρα', it:'bacche', ro:'fructe de padure', uk:'ягоди'}, src: require('@/assets/game-elements/afternoon_snack/berries.png') },
          { category: ["morning_snack", "lunch", "afternoon_snack", "dinner"], name: {en:'carrots', el:'καρότα', it:'carote', ro:'morcovi', uk:'морква'}, src: require('@/assets/game-elements/afternoon_snack/carrots.png') },
          { category: ["morning_snack", "lunch", "afternoon_snack", "dinner"], name: {en:'cucumber', el:'αγγούρι', it:'cetriolo', ro:'castravete', uk:'огірок'}, src: require('@/assets/game-elements/afternoon_snack/cucumber.png') },
          { category: ["breakfast", "morning_snack", "afternoon_snack"], name: {en:'fruit juice', el:'χυμός φρούτων', it:'frutta succo', ro:'suc de fructe', uk:'фруктовий сік'}, src: require('@/assets/game-elements/afternoon_snack/fruit juice.png') },
          { category: ["morning_snack", "afternoon_snack"], name: {en:'hummus', el:'χούμους', it:'hummus', ro:'hummus', uk:'хумус'}, src: require('@/assets/game-elements/afternoon_snack/hummus.png') },
          // { category: ["afternoon_snack", "dinner"], name: {en:'oil', el:'λάδι', it:'olio', ro:'ulei', uk:'масло'}, src: require('@/assets/game-elements/afternoon_snack/oil-1.png') },
          { category: ["morning_snack", "lunch", "afternoon_snack", "dinner"], name: {en:'veggetables', el:'λαχανικά', it:'verdure', ro:'legume', uk:'овочів'}, src: require('@/assets/game-elements/afternoon_snack/veggetables.png') },
        ],
        dinner: [
          { category: ["breakfast", "lunch" , "dinner"], name: {en:'multi-grain bread', el:'πολύσπορο ψωμί', it:'pane multicereali', ro:'pâine cu mai multe cereale', uk:'багатозерновий хліб'}, src: require('@/assets/game-elements/dinner/multi-grain bread.png') },
          { category: ["lunch", "dinner"], name: {en:'shellfish', el:'οστρακοειδή', it:'crostacei', ro:'crustacee', uk:'молюски'}, src: require('@/assets/game-elements/dinner/shellfish.png') },
          { category: ["lunch", "dinner"], name: {en:'swordfish', el:'ξιφίας', it:'pesce spada', ro:'pește-spadă', uk:'риба-меч'}, src: require('@/assets/game-elements/dinner/swordfish.png') },
          { category: ["lunch", "dinner"], name: {en:'turkey', el:'γαλοπούλα', it:'tacchino', ro:'curcan', uk:'індичка'}, src: require('@/assets/game-elements/dinner/turkey.png') },
          { category: ["lunch", "dinner"], name: {en:'white fish', el:'λευκό ψάρι', it:'pesce bianco', ro:'pește alb', uk:'біла риба'}, src: require('@/assets/game-elements/dinner/white fish.png') },
          { category: ["lunch", "dinner"], name: {en:'whole-wheat pasta', el:'ζυμαρικά ολικής αλέσεως', it:'pasta integrale', ro:'paste din grâu integral', uk:'цільнозернові макарони'}, src: require('@/assets/game-elements/dinner/whole-wheat pasta.png') },
          { category: ["lunch", "dinner"], name: {en:'buckwheat', el:'φαγόπυρο', it:'grano saraceno', ro:'hrişcă', uk:'гречана крупа'}, src: require('@/assets/game-elements/dinner/buckwheat.png') },
        ],
      },
      currentFoods: [],
      slot: {
        breakfast: [],
        morning_snack: [],
        lunch: [],
        afternoon_snack: [],
        dinner: [],
      },
      score: 0,
      round: 0,
      maxRounds: 9,
      badgeMessage: '',
      badgeType: '',
      scoreThreshold: 50,
      roundLocked: false,
    };
  },
  methods: {
    log(evt) {
      window.console.log(evt);
    },
    async goBack() {
      sounds.whoosh.play();
      if (sounds.food_game) {
        sounds.food_game.stop();
      }
      this.$router.push({ name: 'GameSelection' });
    },
    startGame() {
      this.overlayMessage = {     en: "Plan your meals!",     el: "Αντιστοίχισε το φαγητό με το γεύμα της ημέρας!",     it: "Pianifica i tuoi pasti!",     ro: "Planifică-ți mesele!",     uk: "Плануй своє харчування!" };      this.isOverlayVisible = true;
    },
    onStartGame() {
      Howler.ctx.resume();
      this.isOverlayVisible = false;
      this.resetGame();
      // Play a sound
      sounds.start_sound.play();
      // Play background music after user interaction, with a short delay
      setTimeout(() => {
        sounds.food_game.play();
      }, 500);
    },
    resetGame() {
      this.score = 0;
      this.round = 0;
      this.loadNewFoods();
    },
    nextRound() {
      if (this.round > this.maxRounds) {
        this.endGame();
        return;
      }
    },
    loadNewFoods() {
      const allFoods = Object.values(this.categories).flat();

      // Filter out the foods that are already in the slot
      const usedFoods = Object.values(this.slot).flat();
      const availableFoods = allFoods.filter(food => !usedFoods.includes(food));

      // Shuffle the remaining foods and pick one
      this.currentFoods = this.shuffleArray(availableFoods).slice(0, 1);
    },
    shuffleArray(array) {
      return array.sort(() => Math.random() - 0.5);
    },
    placeFoodInSlot(categoryKey) {
      // Prevent extra drops after round ends
      if (this.roundLocked) return; // ignore extra drops after round ends
      this.roundLocked = true;

      console.log("categoryKey: ", categoryKey);

      // Get the first food item in the currentFoods array
      const foodItem = this.currentFoods[0];

      console.log("foodItem: ", foodItem);

      // Check if the selected food belongs to the correct category
      if (foodItem.category.includes(categoryKey)) {
        // Add the selected food to the respective category in the slot
        this.slot[categoryKey].push(foodItem);
        const index = this.slot[categoryKey].indexOf(foodItem); // Find the index of the item
        if (index > -1) { // Ensure the item exists in the array
          this.slot[categoryKey].splice(index, 1); // Remove the item
        }
        // Remove the food from the currentFoods list (this will clear the array)
        this.currentFoods = this.currentFoods.filter(item => item !== foodItem); // This ensures the food item is properly removed
        // Increase score for correct placement
        this.score += 10;
        // Show success badge
        this.showBadge('success', this.correct_label[this.language]);
        // Play a sound
        sounds.score_sound.play();
      } else {
        // Show a message regardless of correct or wrong category
        this.showBadge('fail', this.wrong_label[this.language]);
        // Play a sound
        sounds.wrong_sound.play();
        const index = this.slot[categoryKey].indexOf(foodItem); // Find the index of the item
        if (index > -1) { // Ensure the item exists in the array
          this.slot[categoryKey].splice(index, 1); // Remove the item
        }
        // Immediately load new foods for a new random food when the answer is wrong
        this.loadNewFoods();
      }

      // If all current foods are sorted, load new foods
      if (this.currentFoods.length === 0 && this.round < this.maxRounds) {
        this.loadNewFoods();
      }

      this.round++;
      setTimeout(() => {
        this.roundLocked = false;
        this.nextRound();
      }, 1000);
    },
    showBadge(type, message) {
      this.badgeType = type;
      this.badgeMessage = message;
      setTimeout(() => {
        this.badgeMessage = '';
      }, 2000);
    },
    async updateSeedPoints(seedType, change) {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const response = await fetch("https://erebus2.athenarc.gr/duse/update-seed-points", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ seedType, change }),
    });

    if (response.ok) {
      console.log(`Seed points updated: ${change} to ${seedType}`);
    } else {
      console.error("Failed to update seed points.");
    }
  } catch (error) {
    console.error("Error updating seed points:", error);
  }
},
    async endGame() {
      if (sounds.food_game) {
        sounds.food_game.stop();
      }
      let seedType = "";
      let change = 0;
      if (this.score > this.scoreThreshold) {
        change = 1; // Win: Gain a seed
      } else {
        change = -1; // Lose: Lose a seed
      }
      if (this.score > this.scoreThreshold) {
        // Play a sound
        sounds.win_sound.play();
      } else {
        // Play a sound
        sounds.lose_sound.play();
      }
      if (this.daypart == 'morning') {
        seedType = "blue";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isMorningWinOverlayVisible = true; // Show overlay at the end
          
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isMorningLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'noon') {
        seedType = "red";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isNoonWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isNoonLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'afternoon') {
        seedType = "green";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isAfternoonWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isAfternoonLoseOverlayVisible = true; // Show overlay at the end
        }
      } else if (this.daypart == 'night') {
        seedType = "yellow";
        if (this.score > this.scoreThreshold) {
          this.overlayMessage = {en:`Congratulations! You scored ${this.score} points!`, el:`Συγχαρητήρια! Η βαθμολογία σου είναι ${this.score} πόντοι!`, it:`Congratulazioni! Hai totalizzato ${this.score} punti!`, ro:`Felicitări! Ai obținut ${this.score} puncte!`, uk:`Вітаємо! Ви набрали ${this.score} балів!`};
          this.isEveningWinOverlayVisible = true; // Show overlay at the end
        } else {
          this.overlayMessage = {en:`You scored ${this.score} points. Try again…`, el:`Συγκέντρωσες ${this.score} πόντους. Προσπάθησε ξανά…`, it:`Hai totalizzato ${this.score} punti. Riprova…`, ro:`Ai obținut ${this.score} puncte. Încearcă din nou…`, uk:`Ви набрали ${this.score} балів. Спробуйте ще раз…`};
          this.isEveningLoseOverlayVisible = true; // Show overlay at the end
        }
      }
      // Send seed update to the backend
      await this.updateSeedPoints(seedType, change);

      setTimeout(() => {
        this.$router.push({ name: 'GameSelection' }); // Redirect after delay
      }, 3000); // 3 seconds delay
    },
    formatCategoryName(categoryKey) {
      return categoryKey.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    },

    async storeInIndexedDB(gameState) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);
    request.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("gameStates")) {
        db.createObjectStore("gameStates", { keyPath: "id", autoIncrement: true });
      }
    };

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readwrite");
      const store = transaction.objectStore("gameStates");

      // Check for existing game state before saving
      const getAllRequest = store.getAll();
      getAllRequest.onsuccess = function () {
        const existingRecords = getAllRequest.result;
        const duplicate = existingRecords.find(
          (record) => record.gameName === gameState.gameName && record.datePlayed === gameState.datePlayed
        );

        if (!duplicate) {
          store.add(gameState);
        } else {
          console.warn("Duplicate game state detected. Skipping save.");
        }

        resolve();
      };

      getAllRequest.onerror = function (event) {
        reject("Error checking existing records:", event.target.error);
      };
    };

    request.onerror = function (event) {
      reject("Error opening IndexedDB:", event.target.error);
    };
  });
}
,

async getUnsyncedGameStates() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readonly");
      const store = transaction.objectStore("gameStates");

      const getAllRequest = store.getAll();
      getAllRequest.onsuccess = function () {
        resolve(getAllRequest.result);
      };
      getAllRequest.onerror = function (event) {
        reject("Error retrieving game states:", event.target.error);
      };
    };
  });
},

async deleteSyncedGameStates(syncedGames) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("GameDB", 1);

    request.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction("gameStates", "readwrite");
      const store = transaction.objectStore("gameStates");

      syncedGames.forEach((game) => {
        store.delete(game.id); // Delete only specific records
      });

      resolve();
    };

    request.onerror = function (event) {
      reject("Error clearing IndexedDB:", event.target.error);
    };
  });
}
,
async syncWithMongo() {
  if (this.isSyncing) return; // Prevent duplicate sync
  this.isSyncing = true;

  const token = localStorage.getItem("token");
  if (!token) {
    console.error("User not authenticated. Cannot sync.");
    this.isSyncing = false;
    return;
  }

  try {
    const unsyncedGames = await this.getUnsyncedGameStates();
    if (unsyncedGames.length === 0) {
      console.log("No game states to sync.");
      this.isSyncing = false;
      return;
    }

    const response = await fetch("https://erebus2.athenarc.gr/duse/save-game-state", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ gameStates: unsyncedGames }),
    });

    if (response.ok) {
      console.log("Game states synced successfully.");
      await this.deleteSyncedGameStates(unsyncedGames);
    } else {
      console.error("Failed to sync game states.");
    }
  } catch (error) {
    console.error("Error syncing with MongoDB:", error);
  } finally {
    this.isSyncing = false; // Ensure flag is reset
  }
},
    async saveGameState() {
  const token = localStorage.getItem("token");
  const username = localStorage.getItem("username");

  if (!username) {
    console.error("User not logged in. Cannot save game state.");
    return;
  }

  const gameState = {
    username,
    gameName: this.$route.name,
    score: this.score,
    datePlayed: new Date().toISOString(),
  };

  try {
    // Store in IndexedDB regardless of network status
    await this.storeInIndexedDB(gameState);

    if (navigator.onLine && token) {
      await this.syncWithMongo();
    } else {
      console.warn("No internet connection. Game state saved locally.");
    }
  } catch (error) {
    console.error("Error saving game state:", error);
  }
},

  },
  created()
  {
    this.language = localStorage.getItem("language") || "en"; // Default to English
    console.log("LANGUAGE "+this.language);
  },

  mounted() {
  console.log("Current route path:", this.$route.path);

  const daypart = this.$route.path.split("/")[2] || "daypart";
  this.daypart = daypart;
  this.startGame();

  // Check for internet connectivity
  window.addEventListener("online", async () => {
    console.log("Back online! Syncing game states...");
    await this.syncWithMongo();
  });
},
  beforeUnmount() {
    if (sounds.food_game) {
      sounds.food_game.stop();
    }
    clearInterval(this.timer);
    clearInterval(this.turnTimer);
    this.saveGameState();
  },
  beforeRouteLeave(to, from, next) {
    if (sounds.food_game) {
      sounds.food_game.stop();
    }
    // Save game state when the user navigates away
    this.saveGameState();
    next();
  },
 

};
</script>

<style scoped>
.horizontal-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.horizontal-list .list-group-item {
  flex: 0 0 auto;
}

.meal-planner-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: manual;
}

.game-stats {
  position: absolute;
  top: 20px;
  right: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* background: rgba(0, 0, 0, 0.5); */
  padding: 10px;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  font-weight: bold;
}

.food-container-item img {
  max-width: 80px;
  max-height: 80px;
  width: auto;
  height: auto;
  object-fit: cover;
}

#food-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  margin-left: 10vw;
}

#category-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
}

.badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: white;
  padding: 10px 20px;
  border-radius: 10px;
  text-align: center;
}

.badge.success {
  background-color: green;
}

.badge.fail {
  background-color: red;
}

@keyframes badgeFadeIn {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.8);
  }

  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

/* .bordered {
  border: 2px solid rgb(0, 0, 0);
  padding: 20px 0px;
  border-radius: 8px;
} */

.middle-right-container {
  position: fixed;
  top: 50%;
  right: 1%;
  transform: translateY(-50%);
  width: 150px;
  color: white;
  font-size: 5vw;
}

.middle-left-container-1 {
  background-color: rgba(255, 255, 255, 0.4);
  position: fixed;
  top: 26%;
  left: 1%;
  transform: translateY(-50%);
  width: 250px;
}

.middle-left-container-2 {
  background-color: rgba(255, 255, 255, 0.4);
  position: fixed;
  top: 42%;
  left: 1%;
  transform: translateY(-50%);
  width: 250px;
}

.middle-left-container-3 {
  background-color: rgba(255, 255, 255, 0.4);
  position: fixed;
  top: 58%;
  left: 1%;
  transform: translateY(-50%);
  width: 250px;
}

.middle-left-container-4 {
  background-color: rgba(255, 255, 255, 0.4);
  position: fixed;
  top: 74%;
  left: 1%;
  transform: translateY(-50%);
  width: 250px;
}

.middle-left-container-5 {
  background-color: rgba(255, 255, 255, 0.4);
  position: fixed;
  top: 90%;
  left: 1%;
  transform: translateY(-50%);
  width: 250px;
}

.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  z-index: 1001;
}

/* Ensure the drop area has fixed dimensions */
.list-group.horizontal-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* Align items vertically if necessary */
  justify-content: center;
  /* Align items horizontally */
  height: 50px;
  /* Fixed height */
  width: 100%;
  /* Adjust width as needed */
  box-sizing: border-box;
  /* Include padding in the element's dimensions */
}

.food-container-item div {
  font-size: 2vmin;
  text-align: center;
  color: white;
}
</style>
